// All six lists, the locations and the counterparties, refetched only when something is added.
//
// One request per resource rather than seven for the lists: the capture form needs all of them at
// once, and the server serves them together for that reason.

import { useCallback, useEffect, useState } from 'react';

import { getReferenceLists, listCounterparties, listLocations } from '../api.js';

const EMPTY = {
  product: [],
  grade: [],
  unit: [],
  currency: [],
  incoterms: [],
  payment_terms: [],
};

// `enabled` false asks for nothing, for a screen that needs the lists only with a feature on.
export function useReferenceLists({ enabled = true } = {}) {
  const [lists, setLists] = useState(EMPTY);
  const [counterparties, setCounterparties] = useState([]);
  // Locations are structured records with their own endpoint, not one of the six code lists.
  const [locations, setLocations] = useState([]);
  const [error, setError] = useState(null);

  const refresh = useCallback(() => {
    if (!enabled) return;
    getReferenceLists()
      .then((data) => setLists({ ...EMPTY, ...data }))
      .catch((err) => setError(err.message));
    listLocations().then(setLocations).catch((err) => setError(err.message));
    // A failure here is not fatal: counterparties are optional on a draft, and a BD can still
    // type a name as free text.
    listCounterparties().then(setCounterparties).catch(() => {});
  }, [enabled]);

  useEffect(refresh, [refresh]);

  return { ...lists, locations, counterparties, refresh, error };
}
